import React from "react";
import "./AboutUs.css";

export default function AboutUs() {
  return (
    <div className="about-us">
      <section className="page-hero">
        <div className="container">
          <h1>Our Story</h1>
          <p> Determined to make the road ahead a little easier for every family who follows. </p>
        </div>
      </section>

      <section>
        <div className="container story-body">
          <p>
            The Bug and Frog Foundation was born from two small beginnings and two
            life-changing NICU journeys. After Mariah’s children, Juniper and August,
            were born prematurely, she experienced firsthand how overwhelming it can
            be to care for a medically fragile baby while also navigating hospital
            stays, mounting expenses, unfamiliar equipment, and the emotional weight
            of becoming a parent in the NICU.
          </p>
          <p>
            What began as a desire to make that journey less isolating has grown into
            a mission to support families through both the practical and emotional
            challenges of premature birth. The foundation is focused on providing
            financial relief, essential care items, trusted resources, and tools that
            help caregivers organize the many details competing for their attention
            during and after a NICU stay.
          </p>
          <p>
            Our approach is shaped by lived experience and a simple belief: caregivers
            should not have to navigate this journey alone. By combining direct
            assistance with thoughtful technology and community support, we hope to
            ease the everyday burdens families face so they can spend more time
            caring for their babies, celebrating each milestone, and moving toward
            the mighty leaps ahead.
          </p>
        </div>

      </section>

      <section className="section-alt">
        <div className="container values-grid">
          <div className="value-card">
            <h3>Our Mission</h3>
            <p>
              To ease the practical, financial, and emotional burdens of the NICU
              journey by connecting families with meaningful support, essential
              resources, and compassionate community.
            </p>
          </div>
          <div className="value-card">
            <h3>Our Values</h3>
            <p>
              We are guided by compassion, dignity, inclusion, and lived experience.
              We listen to caregivers, respond to real needs, and celebrate every
              family’s progress, no matter how small the milestone may seem.
            </p>
          </div>
          <div className="value-card">
            <h3>Our Vision</h3>
            <p>
              A future where every NICU family feels supported, informed, and less
              alone, and where no caregiver is forced to choose between meeting basic needs and
              being present for their baby.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
